export const SORE_FEEDBACK = {
    GOOD: 10,
    PAINFUL: 20
}
export const SKIP_TEST_REASONS = {
    PAINFUL: 10,
    DONT_UNDERSTAND: 20,
    SHORT_TIME: 30,
    SKIP_ONE_WEEK: 40,
}